exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.mb8 {\r\n  margin-bottom: 8px;\n}\n.p6 {\r\n  padding: 6px;\n}\r\n", "", {"version":3,"sources":["/Volumes/aigoWork/Workspace/ying-zheng/yz-server/front_end/jjj_shop_multi_shop/src/views/plus/table/table/part/Fields.vue"],"names":[],"mappings":";AACA;EACE,mBAAmB;CACpB;AACD;EACE,aAAa;CACd","file":"Fields.vue","sourcesContent":["\n.mb8 {\r\n  margin-bottom: 8px;\n}\n.p6 {\r\n  padding: 6px;\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-296c08ee","scoped":false,"hasInlineConfig":false}!./node_modules/postcss-loader/lib?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/plus/table/table/part/Fields.vue
// module id = q0pv
// module chunks = 0